import { getToken } from "./auth";
import { v4 as uuidv4 } from "uuid";
const bucketUrl = "https://d2yhk23ciu9dj0.cloudfront.net/";
const api_url = "https://api.softplix.com/api/";

export async function getUsers({ page }) {
  try {
    const token = getToken();

    const response = await fetch(`${api_url}admin/getPalmData/${page}`, {
      method: "GET",

      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("something went wrong");
    }

    const res = await response.json();

    return res;
  } catch (e) {
    throw new Error("something went wrong");
  }
}
export async function getSearchUsers({ searchTerm }) {
  try {
    const token = getToken();

    const response = await fetch(`${api_url}admin/searchUser/${searchTerm}`, {
      method: "GET",

      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("something went wrong");
    }

    const res = await response.json();

    return res;
  } catch (e) {
    throw new Error("something went wrong");
  }
}
export async function getImageUrl({ folder, image }) {
  try {
    const token = getToken();
    const imageName = uuidv4();
    const value = {
      fileName: `palm/${imageName}.jpg`,
      contentType: "image/jpg",
    };
    const response = await fetch(`${api_url}/admin/generatePresignedUrl`, {
      method: "POST",
      body: JSON.stringify(value),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("something went wrong");
    }

    const { data } = await response.json();

    const putResponse = await fetch(data[0].result, {
      method: "PUT",
      headers: {
        "Content-Type": "image/jpg",
      },
      body: image,
      mode: "cors",
    });

    if (!putResponse.ok) {
      throw new Error("something went wrong");
    }
    console.log(`${bucketUrl}${folder}/${imageName}.jpg`, "image url");
    return `${bucketUrl}${folder}/${imageName}.jpg`;
  } catch (e) {
    throw new Error("something went wrong");
  }
}
export async function uploadPalm(data) {
  try {
    const token = getToken();

    const value = {
      name: data.name,
      dob: data.dob,
      place_of_birth: data.place_of_birth,
      time_of_birth: data.time_of_birth,
      mobile: data.mobile,
      created_by: "Harsh",
      prediction: data.prediction,
      images: data.images,
    };
    const response = await fetch(`${api_url}/admin/addPalm`, {
      method: "POST",
      body: JSON.stringify(value),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("something went wrong");
    }

    return `uploaded`;
  } catch (e) {
    throw new Error("something went wrong");
  }
}
export async function updatePalm(data) {
  try {
    const token = getToken();

    const value = {
      name: data.name,
      dob: data.dob,
      place_of_birth: data.place_of_birth,
      time_of_birth: data.time_of_birth,
      mobile: data.mobile,
      created_by: "Harsh",
      prediction: data.prediction,
      image: data.images[0] ?? "",
      images: data.images,
    };
    const response = await fetch(`${api_url}/admin/updatePalm/${data.id}`, {
      method: "POST",
      body: JSON.stringify(value),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      throw new Error("something went wrong");
    }

    return `uploaded`;
  } catch (e) {
    throw new Error("something went wrong");
  }
}
